import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import { useLang } from "../contexts/LanguageContext";

const LANGS = [
    { code: "es", label: "Español", flag: "🇪🇸" },
    { code: "en", label: "English", flag: "🇬🇧" },
];

export default function LanguageSelector() {
    const { lang, setLang, t } = useLang();
    const current = LANGS.find((l) => l.code === lang) || LANGS[0];

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    className="rf-btn !px-2"
                    data-testid="language-btn"
                    title={t("language")}
                >
                    <i className="fa-solid fa-globe"></i>
                    <span className="uppercase font-semibold text-[12px]">
                        {current.code}
                    </span>
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                className="bg-[var(--bg-card-solid)] border border-[var(--border-strong)] text-[var(--text-primary)] !z-[2000] min-w-[150px]"
                align="end"
            >
                {LANGS.map((l) => (
                    <DropdownMenuItem
                        key={l.code}
                        className={`cursor-pointer focus:bg-[var(--accent-soft)] focus:text-[var(--accent)] ${
                            l.code === lang ? "text-[var(--accent)]" : ""
                        }`}
                        onClick={() => setLang(l.code)}
                        data-testid={`lang-${l.code}`}
                    >
                        <span className="mr-2">{l.flag}</span>
                        {l.label}
                        {l.code === lang && (
                            <i className="fa-solid fa-check ml-auto"></i>
                        )}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
